import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import LanguageDetector from "i18next-browser-languagedetector";

i18n
  .use(LanguageDetector) // Определяет язык
  .use(initReactI18next) // Подключение к React
  .init({
    fallbackLng: "en", // Язык по умолчанию
    supportedLngs: ["en", "ru", "am"], // Поддерживаемые языки
    debug: true,
    interpolation: {
      escapeValue: false, // React сам экранирует
    },
    detection: {
      order: ["localStorage", "navigator"],
      caches: ["localStorage"],
      lookupLocalStorage: "i18nextLng",
      checkWhitelist: true,
    },
    resources: {
      en: {
        translation: require("./i18n/en/translation.json"),
      },
      am: {
        translation: require("./i18n/am/translation.json"),
      },
      ru: {
        translation: require("./i18n/ru/translation.json"),
      },
    },
  });

export default i18n;
